// eslint-disable-next-line no-restricted-imports
import { Percent } from '@kodiak-finance/sdk-core'
import { ReactComponent as SettingsIcon } from 'assets/svg/icons/Settings.svg'
import { ProvidersConfigProps } from 'components/swap/SwapHeader'
import { isSupportedChain } from 'config/chains'
import { useConnection } from 'hooks/useConnection'
import { useRef } from 'react'
import { Text } from 'rebass'
import styled from 'styled-components'

import { useOnClickOutside } from '../../hooks/useOnClickOutside'
import { useModalIsOpen, useToggleSettingsMenu } from '../../state/application/hooks'
import { ApplicationModal } from '../../state/application/reducer'
import { AutoColumn } from '../Column'
import TransactionSettings from '../TransactionSettings'

const StyledSettings = styled(SettingsIcon)`
  color: ${({ theme }) => theme.textPrimary};
`

const StyledMenuButton = styled.button<{ disabled: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ disabled }) =>
    !disabled &&
    `
    :hover,
    :focus {
      cursor: pointer;
      outline: none;
      opacity: 0.7;
    }
  `}
`
// const EmojiWrapper = styled.div`
//   position: absolute;
//   bottom: -6px;
//   right: -6px;
//   font-size: 14px;
// `

const StyledMenu = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border: none;
`

const MenuFlyout = styled.span`
  /* min-width: 20.125rem; */
  min-width: 330px;
  background-color: ${({ theme }) => theme.cardPrimary};
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  position: absolute;
  top: 3rem;
  right: 0rem;
  z-index: 100;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    min-width: 18.125rem;
  `};

  user-select: none;
`

export default function SettingsTab({
  isTwap,
  placeholderSlippage,
  providersConfig,
}: {
  isTwap: boolean
  placeholderSlippage: Percent
  providersConfig?: ProvidersConfigProps
}) {
  const { chainId } = useConnection()

  const node = useRef<HTMLDivElement>()
  const open = useModalIsOpen(ApplicationModal.SETTINGS)
  const toggle = useToggleSettingsMenu()

  useOnClickOutside(node, open ? toggle : undefined)

  return (
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/30451
    <StyledMenu ref={node as any}>
      <StyledMenuButton
        disabled={!isSupportedChain(chainId)}
        onClick={toggle}
        id="open-settings-dialog-button"
        aria-label="Transaction Settings"
      >
        <StyledSettings />
      </StyledMenuButton>
      {open && (
        <MenuFlyout>
          <AutoColumn gap="md" style={{ padding: '1rem' }}>
            <Text fontWeight={600} fontSize={14}>
              <>Transaction Settings</>
            </Text>
            <TransactionSettings
              isTwap={isTwap}
              placeholderSlippage={placeholderSlippage}
              providersConfig={
                providersConfig
                  ? {
                      isLoading: providersConfig.isLoading,
                      availableProviders: providersConfig.availableProviders,
                      selectedProviders: providersConfig.selectedProviders,
                      onSelect: providersConfig.onSelect,
                      onReset: providersConfig.onReset,
                      onSelectAll: providersConfig.onSelectAll,
                    }
                  : undefined
              }
            />
          </AutoColumn>
        </MenuFlyout>
      )}
    </StyledMenu>
  )
}
